/**
 * @fileoverview Textarea — catalyst Textarea adapted for light-mode intake forms.
 */
import clsx from 'clsx';
import React, { forwardRef } from 'react';

export interface FormTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  /** Allow vertical resize (default: true) */
  resizable?: boolean;
}

export const FormTextarea = forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  ({ className, invalid, resizable = true, ...props }, ref) => (
    <span
      data-slot="control"
      className={clsx(
        'relative block w-full',
        'before:absolute before:inset-px before:rounded-[7px] before:bg-white before:shadow-sm',
        'after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:ring-transparent after:ring-inset',
        'sm:focus-within:after:ring-2 sm:focus-within:after:ring-blue-500',
        'has-[:disabled]:opacity-50 has-[:disabled]:before:bg-zinc-50 has-[:disabled]:before:shadow-none',
        invalid && 'before:shadow-red-500/10',
      )}
    >
      <textarea
        ref={ref}
        className={clsx(
          className,
          'relative block w-full appearance-none rounded-lg',
          'px-3 py-2 sm:px-3 sm:py-1.5',
          'text-sm text-zinc-900 placeholder:text-zinc-400',
          'border border-zinc-200 hover:border-zinc-300',
          'bg-transparent',
          'focus:outline-none',
          invalid && 'border-red-400 hover:border-red-400',
          'disabled:border-zinc-200 disabled:cursor-not-allowed',
          resizable ? 'resize-y' : 'resize-none',
        )}
        {...props}
      />
    </span>
  ),
);

FormTextarea.displayName = 'FormTextarea';
